module.exports = __webpack_public_path__ + "static/img/11.a6ffce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/11.jpg
// module id = zoT4
// module chunks = 0